import { Controller } from '@hotwired/stimulus'

// Enables/disables an element based on selection state.
// Listens to selection:change events and enables when items are selected.
export default class extends Controller {
  selectionChanged(event) {
    const ids = event.detail?.ids || []
    this.element.disabled = ids.length === 0
  }
}
